module.exports = __webpack_public_path__ + "static/img/16.a6338555.jpg";